var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-editor"},[_c('editor-panel'),(_vm.type === 'lines')?_c('route-card'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }